export interface FilterChoiceDto {
  Name: string;
  Text: string;
  Value: string;
  Children: FilterChoiceDto[];
}

export interface FilterElementDto {
  Type: 'category' | 'list';
  FilterHeading: string;
  FilterTabName: string;
  QueryStringParameter: string;
  ShowModal: boolean;
  ModalHeading: string;
  ModalText: string;
  Choices: FilterChoiceDto[];
}

export interface FilterConfigDto {
  EnableFreeTextSearch: boolean;
  FreeTextHeading: string;
  Heading: string;
  ShowAllButton: boolean;
  FilterElements: FilterElementDto[];
}

export interface TagDto {
  Name: string;
  Chosen: boolean;
}

export interface TipsItemDto {
  Id: number;
  Rubrik: string;
  Ingress: string;
  Beskrivning: string;
  Framtagare: string;
  LankMaterial: string;
  InskickadDatumTid: string;
  DelningsUrl: string;
  MarkeratTips: boolean;
  Nyckelord: TagDto[];
  Typer: TagDto[];
}

export interface TipsResultsDto {
  TotalCount: number;
  CurrentPage: number;
  PageCount: number;
  PageSize: number;
  Items: TipsItemDto[];
}

export async function fetchFilterConfig(contentId: number): Promise<FilterConfigDto> {
  const res = await fetch(`/api/hittatipssida/filter?contentId=${contentId}`);
  if (!res.ok) throw new Error(`Filter config fetch failed: ${res.status}`);
  return res.json();
}

export async function fetchResults(
  contentId: number,
  params: URLSearchParams,
  signal: AbortSignal
): Promise<TipsResultsDto> {
  const res = await fetch(
    `/api/hittatipssida/results?contentId=${contentId}&${params.toString()}`,
    { signal }
  );
  if (!res.ok) throw new Error(`Results fetch failed: ${res.status}`);
  return res.json();
}
